import { useEffect, useState } from 'react';

type TNoSSR = {
  children: JSX.Element;
  fallback?: JSX.Element;
};

export const NoSSR = ({ children, fallback }: TNoSSR) => {
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  if (!children) {
    return fallback || null;
  }

  return isClient ? children : null;
};
